import FloatingElements from '../../FloatingElements'
import Module1 from './Module1'
import Module2 from './Module2'
import Module3 from './Module3'
import Module5 from './Module5'
import ModuleMedallistsOptional from './ModuleMedallistsPhase1_5'
import ModuleMedallistsPhase2 from './ModuleMedallistsPhase2'
import ModuleMedallistsPhase3 from './ModuleMedallistsPhase3'
import ModuleMedallistsPhase2_5 from './ModuleMedallistsPhase3'

const Phone = (props: any) => {
  return (
    <>
      <Module1 {...props} />
      {props?.medallistBlock === 'phase1.5MedallistAnnounced' && <ModuleMedallistsOptional  {...props} />}
      {props?.medallistBlock === 'phase2MedallistAnnounced' && <ModuleMedallistsPhase2 {...props} />}
      {props?.medallistBlock === 'phase2.5MedallistAnnounced' && <ModuleMedallistsPhase2_5 {...props} />}
      {props?.medallistBlock === 'phase3MedallistAnnounced' && <ModuleMedallistsPhase3 {...props} />}
      <Module2 {...props} />
      <Module3 {...props} />
      <Module5 {...props} />
      <FloatingElements />
    </>
  )
}

export default Phone
